import Director from './Director';
import Timekeeper from './Timekeeper';
import Marshal from './Marshal';

const terminals = [Director, Timekeeper, Marshal];

export default terminals;



// WEBPACK FOOTER //
// ./src/terminals/index.js